import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import DashboardPage from "./pages/dashboard";
import TemperatureDashboardPage from "./pages/temperature";
import CategoryPage from "./pages/category";
import SensorPage from "./pages/sensor";

import FoodTemperaturePage from "./pages/checks/FoodTemperature";
import DynamicCheckPage from "./pages/checks/DynamicCheck";
import CheckPage from "./pages/checks";

import IncidentLogPage from "./pages/incident-log";
import IncidentDashboardPage from "./pages/incident";

import EquipmentPage from "./pages/equipment";
import AddEquipmentPage from "./pages/equipment/addEquipment";

import UsersPage from "./pages/users";
import DepartmentsPage from './pages/users/departments';
import JobTitlesPage from './pages/users/jobTitles';
import CreateUsersPage from "./pages/users/create";
import UserDetailPage from "./pages/users/detail";
import EditUserPage from "./pages/users/edit";

import RotaPage from "./pages/rota";
import RotaFormPage from "./pages/rota/form";



import LoginPage from "./pages/login";
import PasswordRecoveryPage from "./pages/passwordRecovery";
import ProtectedRoute from "./routes/ProtectedRoute";

import ComplianceCenterPage from "./pages/compliance-center";
import ChecksComplianceCenterPage from "./pages/compliance-center/ChecksComplianceCenter";
import EquipmentComplianceCenter from "./pages/compliance-center/EquipmentComplianceCenter";
import FireSafetyComplianceCenter from "./pages/compliance-center/FireSafetyComplianceCenter";
import IncidentComplianceCenter from "./pages/compliance-center/IncidentComplianceCenter";

import PATMonthlyCheckPage from "./pages/checks/PATMonthlyCheck";
import MonthlyAlerginCheckPage from "./pages/checks/MonthlyAlerginCheck";
import MonthlyStaffTrainingCheckPage from "./pages/checks/MonthlyStaffTrainingCheck";

import DeliveryCheckTemplate from "./pages/checks/DeliveryCheck";
import DeliveryCheckCreateTemplate from "./pages/checks/DeliveryCheck/CreateTemplate";
import DeliveryCheckDetailTemplate from "./pages/checks/DeliveryCheck/DetailTemplate";

import StaffTrainingPage from "./pages/staff-training";
import AddTrainingRecord from './pages/staff-training/addTrainingRecord';
import EditTrainingRecord from './pages/staff-training/editTrainingRecord';
import ViewTrainingRecord from './pages/staff-training/viewTrainingRecord';
import ViewStaffTraining from './pages/staff-training/viewStaffTraining';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<PasswordRecoveryPage />} />
        <Route path="/reset-password" element={<PasswordRecoveryPage mode="reset" />} />

        {/* Protected */}
        <Route element={<ProtectedRoute />}>
          {/* Dashboard */}
          <Route path="/dashboard" element={<DashboardPage />} />

          {/* Temperature */}
          <Route path="/temperature" element={<TemperatureDashboardPage />} />

          {/* Categories */}
          <Route path="/categories" element={<CategoryPage />} />
          <Route path="/categories/:categoryID" element={<SensorPage />} />

          {/* Checks */}
          <Route path="/checks" element={<CheckPage />} />

          <Route
            path="/checks/temperature-check"
            element={<FoodTemperaturePage />}
          />

          <Route path="/checks/delivery-check" element={<DeliveryCheckTemplate />} />
          <Route path="/checks/delivery-check/create" element={<DeliveryCheckCreateTemplate />} />
          <Route path="/checks/delivery-check/:id" element={<DeliveryCheckDetailTemplate />} />
          <Route path="/checks/:slug" element={<DynamicCheckPage />} />

          {/* Incident */}
          <Route path="/incident-log" element={<IncidentLogPage />} />

          <Route path="/incident" element={<IncidentDashboardPage />} />

          {/* Equipment */}
          <Route path="/equipment" element={<EquipmentPage />} />

          <Route path="/equipment/add" element={<AddEquipmentPage />} />

          {/* Users */}
          <Route path="/users" element={<UsersPage />} />

          <Route path="/users/create" element={<CreateUsersPage />} />
          <Route path="/users/departments" element={<DepartmentsPage />} />
          <Route path="/users/job-titles" element={<JobTitlesPage />} />
          <Route path="/users/:id" element={<UserDetailPage />} />
          <Route path="/users/:id/edit" element={<EditUserPage />} />

          {/* =========================
              ROTA ROUTES
          ========================== */}

          {/* Main Rota */}
          <Route path="/rota" element={<RotaPage />} />
          <Route path="/rota/create" element={<RotaFormPage key="create" />} />
          <Route path="/rota/edit/:id" element={<RotaFormPage key="edit" />} />
          <Route path="/rota/view/:id" element={<RotaFormPage key="view" readOnly />} />

          {/* Add Weekly Rota */}
          <Route path="/rota/add-weekly" element={<Navigate to="/rota/create?period=weekly" replace />} />

          {/* Add Monthly Rota */}
          <Route path="/rota/add-monthly" element={<Navigate to="/rota/create?period=monthly" replace />} />

          {/* Dynamic Rota Detail */}
          <Route path="/rota/:section" element={<Navigate to="/rota" replace />} />

          {/* Staff Training */}
          <Route path="/staff-training" element={<StaffTrainingPage />} />
          <Route path="/staff-training/records/create" element={<AddTrainingRecord />} />
          <Route path="/staff-training/records/:id" element={<ViewTrainingRecord />} />
          <Route path="/staff-training/records/:id/edit" element={<EditTrainingRecord />} />
          <Route path="/staff-training/staff/:staffId" element={<ViewStaffTraining />} />

          {/* Compliance Center */}
          <Route path="/compliance-center" element={<ComplianceCenterPage />} />

          <Route
            path="/compliance-center/checks/:slug"
            element={<ChecksComplianceCenterPage />}
          />

          <Route
            path="/compliance-center/equipment"
            element={<EquipmentComplianceCenter />}
          />

          <Route
            path="/compliance-center/fire-safety"
            element={<FireSafetyComplianceCenter />}
          />

          <Route
            path="/compliance-center/incidents"
            element={<IncidentComplianceCenter />}
          />

          {/* Monthly Checks */}
          <Route
            path="/monthly-alergin-check"
            element={<MonthlyAlerginCheckPage />}
          />

          <Route
            path="/monthly-staff-training-check"
            element={<MonthlyStaffTrainingCheckPage />}
          />

          <Route path="/pat-monthly-check" element={<PATMonthlyCheckPage />} />
        </Route>

        {/* Unknown Route */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
